import { inject, Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { parseBodyFromObject, RequestService } from 'clicklease-ui-elements';
import { environment } from '@envs/environment';
import { Credentials, TokenResponse, UserData, UserInfoData } from './../../interfaces';
import { Store } from '@ngrx/store';
import { getIsAdminSelector } from '../../ngrx';

@Injectable({
    providedIn: 'root'
})
export class AuthService extends RequestService {

    readonly #store = inject(Store);
    readonly isAdmin = this.#store.selectSignal(getIsAdminSelector);

    protected serviceBaseUrl: string = `${environment.API_AUTH_URL}protocol/openid-connect/`;
    protected readonly client_id: string = environment.auth_client_id;
    protected readonly edgar_client_id: string = environment.edgarKeycloak.clientId;

    private clientId: string = environment.auth_client_id;

    public getAuthData(): Observable<UserInfoData> {
        return this.get<UserInfoData>({
            url: 'userinfo',
            headers: {
                'content-type': 'application/x-www-form-urlencoded',
            }
        })
    }

    public login(credentials: Credentials): Observable<TokenResponse> {
        this.checkRouteAndClient();
        return this.post<TokenResponse>({
            url: 'token',
            params: parseBodyFromObject({
                ...credentials,
                grant_type: 'password',
                client_id: this.clientId
            }).toString(),
            headers: {
                'content-type': 'application/x-www-form-urlencoded',
            }
        });
    }

    public logout(token: string): Observable<unknown> {
        this.checkRouteAndClient();
        return this.post({
            url: 'logout',
            params: parseBodyFromObject({
                client_id: this.clientId,
                refresh_token: token
            }).toString(),
            headers: {
                'content-type': 'application/x-www-form-urlencoded',
            }
        })
    }

    public refreshToken(token: string): Observable<TokenResponse> {
        this.checkRouteAndClient();
        return this.post<TokenResponse>({
            url: 'token',
            params: parseBodyFromObject({
                grant_type: 'refresh_token',
                client_id: this.clientId,
                refresh_token: token
            }).toString(),
            headers: {
                'content-type': 'application/x-www-form-urlencoded',
            }
        })
    }

    private checkRouteAndClient(): void {
        if(this.isAdmin()) {
            this.serviceBaseUrl = this.serviceBaseUrl.replace(environment.API_AUTH_URL, environment.edgarKeycloak.API_AUTH_URL);
            this.clientId = environment.edgarKeycloak.clientId;
        }
    }
}